<style lang="css" scoped>

.settingsBtn {
  max-width: 400px;
}

.radio {
  padding: 5px 8px;
  border: 1px solid #eeeeee;
  border-radius: 3px;
}

</style>

<template>

  <v-dialog v-model="dialog" max-width="550">
    <template v-slot:activator="{ on }">
        <v-btn dark color="grey darken-2" block v-on="on" class="mx-3 settingsBtn">
          <v-icon right dark class="mx-2">settings</v-icon>
          {{content.settings}}
        </v-btn>
    </template>
    <v-form @submit.prevent="save()">
      <v-card>
        <v-card-title class="headline text-xs-center">
          <v-icon right class="mx-2">settings</v-icon>
          {{content.settings}}
        </v-card-title>
        <v-card-text>
          <v-layout row wrap>
            <v-text-field :label="content.name" :hint="content.name_max_length" v-model="edit.name" :rules="rules.name"></v-text-field>
          </v-layout>
          <v-spacer></v-spacer>
          <v-layout v-if="!type" row wrap>
            <v-flex d-flex grow align-center align-content-center>
              <h3>{{content.role}}:</h3>
            </v-flex>
            <v-flex shrink>
              <v-radio-group v-model="edit.role" row>
                <v-radio class="radio" color="primary" :label="content.controller" value="1"></v-radio>
                <v-radio class="radio" color="primary" :label="content.sensors" value="0"></v-radio>
              </v-radio-group>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-layout row wrap justify-space-between>
            <v-flex shrink>
              <v-btn type="submit" color="success" :loading="loading" shrink>{{content.save}}</v-btn>
            </v-flex>
            <v-flex shrink>
              <Delete :slug="slug" @toggleSettings="toggle" shrink />
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>

</template>

<script>

import Delete from './itemdelete'
export default {
    props: ['name', 'role', 'slug', 'type'],
    components: { Delete },
    data() {
        return {
          locale: null,
          textDir: 'text-xs-right',
          dialog: false,
          loading: null,

          edit: {
            name: this.name,
            role: this.role + '',
          },
          rules: {
            name: [
              v => !!v || this.content.rules.name[0],
              v => v && v.length <= 25 || this.content.rules.name[1],
            ],
          },
        }
    },
    created() {
      this.locale = Lang.get();
      this.setLang();
      this.textDir = this.locale == 'he' ? 'text-xs-left' : this.textDir;
    },
    watch: {
      name(){
        if (this.name == this.edit.name && this.role == this.edit.role) {
          this.dialog = false;
          this.loading = false;
        }
      },
      role(){
        if (this.name == this.edit.name && this.role == this.edit.role) {
          this.dialog = false;
          this.loading = false;
        }
      }
    },
    methods: {
        save(){
          this.loading = true;
          let data = {
            slug: this.slug,
            action: 'edit',
            modify: {
              name: this.edit.name,
              role: this.edit.role,
            },
          }
          this.$store.dispatch('devices/modifyDevice', data);
        },
        toggle(status) {
          this.dialog = status;
        },
        setLang() {
            if (this.locale == "en") {
                this.content = {
                    save: 'Save',
                    cancel: 'Cancel',
                    close: 'Close',
                    settings: 'Settings',
                    name: 'Name',
                    name_max_length: 'Max length 25 characters',
                    role: 'Unit\'s Role',
                    controller: 'Controller',
                    sensors: 'Sensors',
                    rules: {
                      name : [
                        'Name is required',
                        'The name cannot be longer than 25 characters'
                      ],
                    }
                };
            } else if (this.locale == "he") {
                this.content = {
                    save: 'שמירה',
                    cancel: 'ביטול',
                    close: 'סגירה',
                    settings: 'הגדרות',
                    name: 'שם',
                    name_max_length: 'מקסימום של 25 תווים',
                    role: 'תפקיד היחידה',
                    controller: 'בקר',
                    sensors: 'חיישנים',
                    rules: {
                      name: [
                        'חובה למלא שם',
                        'השם לא יכול להיות ארוך מ-25 תווים',
                      ],
                    }
                };
            }
        },
    }
}

</script>
